import { message } from 'antd';
import type { AdminUser } from '@/services/admin-auth';
import { getAdminUser } from '@/services/admin-auth';

const SUPER_ADMIN_ROLES = new Set(['SUPER_ADMIN', 'ROLE_SUPER_ADMIN']);
const SUPER_ADMIN_PERMISSION_HINTS = new Set([
  'super_admin',
  'super:admin',
  'admin:super',
]);

const normalize = (value?: string | null) => (value || '').trim().toUpperCase();

export const isSuperAdmin = (adminUser?: AdminUser | null): boolean => {
  const user = adminUser ?? getAdminUser();
  if (!user) {
    return false;
  }

  if (SUPER_ADMIN_ROLES.has(normalize(user.role))) {
    return true;
  }

  return (user.permissions || []).some((permission) =>
    SUPER_ADMIN_PERMISSION_HINTS.has((permission || '').toLowerCase()),
  );
};

export const ensureSuperAdminForDelete = (
  actionLabel = '删除操作',
): boolean => {
  if (isSuperAdmin()) {
    return true;
  }
  message.warning(`仅超级管理员可执行${actionLabel}`);
  return false;
};
